import { DsFormTemplateFieldType } from '../../types/ds-form-template-field.type';
import { DsFormsExcelResultInterface } from '../../interfaces/forms-excel/ds-forms-excel-result.interface';

export class DsFormsExcelResult {
  [key: string]: DsFormTemplateFieldType[];

  /**
   * Creates an instance of DsFormsExcelResult.
   *
   * @param json Given object
   */
  constructor(json: DsFormsExcelResultInterface) {
    if (!json) {
      return;
    }
    Object.keys(json).forEach((key) => {
      this[key] = json[key];
    });
  }
}
